__turbopack_context__.v({
  "afterCopyrightBar": "eBTcHq_afterCopyrightBar",
});
